import { HandleSectionClick } from "./contentsection";
import $ from "jquery";
import { fetchContent, updateState } from "./counterSlice";
import { getUrlObj } from "../../utils";
import { processDitaCitationsInDOM } from "../citations";
import PrepareMathML from "./prepareMathML";
import imageMapResize from "image-map-resizer";

let PrepareToView = (
  dateinfo,
  dartSelectors,
  topicfile,
  isMobileView = false,
  isModernView = false,
  toast,
  setReferencePopup = null,
  setIsCalculator,
  setCalculatorType,
  isWebModernisationEnabled = false,
) => {
  PrepareColapseContent(dartSelectors);
  PrepareTable(dartSelectors);

  PrepareMathML();
  PrepareImages(dartSelectors);
  PrepareImagemap(dartSelectors);
  PrepareFootNotes(dartSelectors, isModernView);
  PrepareTableLables(dartSelectors, isMobileView);
  PrepareFigureLables(dartSelectors, isMobileView);
  PrepareTandFLinks(dartSelectors, isModernView);
  PerpareXrefs(dartSelectors);
  // ApplyPubmedIcon(dartSelectors);

  GetPublishedDate(dateinfo, dartSelectors);
  UnpackQuickLinks(dartSelectors);
  PrepareConrefs(dartSelectors);
  PrepareTerms(dartSelectors);

  // Process DITA citations - convert <xref><cite> elements to numbered citation links
  // Add setReferencePopup to dartSelectors for modern web support
  const enhancedDartSelectors = { ...dartSelectors, setReferencePopup };
  if (isWebModernisationEnabled) {
    processDitaCitationsInDOM(enhancedDartSelectors).catch((error) => {
      console.error("Error processing DITA citations:", error);
    });
  }

  setTimeout(() => {
    HandleSectionClick(
      dartSelectors,
      updateState,
      topicfile,
      isMobileView,
      isModernView,
      toast,
      setIsCalculator,
      setCalculatorType,
    ); // this is in contentSection. Needs to be called after 1 second so drug information notes links bind. For some reason 2 seconds causes drug info buttons to fail.
    // run these after to prevent .off() unbind on xref.
  }, 1000);
  if (dartSelectors.uxPlatform === "mobile") {
    $(".etgtopic .bodyContentDiv").css("display", "none");
  }
};

let UnpackQuickLinks = (dartSelectors) => {
  // console.log("force update",dartSelectors.referenceFiles.refContent.active);
  if (dartSelectors.referenceFiles.refContent.active === 0) return; // don't bother since modal is closed.
};

let PrepareConrefs = (dartSelectors) => {
  let uxConfref = $("#contentId [conref]");
  $(uxConfref).each((index, element) => {
    element = $(element);
    let conrefLink = element.attr("conref");
    conrefLink = conrefLink.split("#");

    if (conrefLink[0].includes("pbf")) {
      conrefLink[0] = conrefLink[0].replace("../pbf", "quicklinks/pbf");
    } else {
      conrefLink[0] = dartSelectors.ditapath + conrefLink[0];
    }

    // console.log("CONREF:",conrefLink[0],conrefLink[1]);
    conrefLink[0] = conrefLink[0].replace("../", "/");

    dartSelectors.iDB.read(conrefLink[0]).then((value) => {
      // console.log("Dita file: " + conrefLink[0]);
      if (value !== null) {
        // console.log(value);
        value = $("<body />").html(value);

        try {
          element.append(
            $(value)
              .find("#" + conrefLink[1].replace(/\//g, " #"))
              .html(),
          );
        } catch (error) {
          console.log(error);
        }
      } else {
        dartSelectors.dispatch(
          fetchContent({
            guideline: "",
            topicFile: conrefLink[0],
            dartSelectors,
          }),
        );
      }
    });
  });
};

let PrepareTerms = (dartSelectors) => {
  let uxTerms = $("#contentId term");
  $(uxTerms).each((index, element) => {
    let outputClass = $(element).attr("outputclass");

    if (outputClass === "tgl_preg") {
      $(element).attr("title", "Check pregnancy categorisation");
    } else if (outputClass === "tgl_breast") {
      $(element).attr("title", "Check breastfeeding advice");
    }
  });
};

let GetPublishedDate = (dateinfo, dartSelectors) => {
  let versionInfoFile = $("bookmap>chapter:eq(0)").attr("href");
  if (versionInfoFile === undefined) return;
  versionInfoFile = versionInfoFile.split("/").splice(-1)[0];
  dartSelectors.iDB.read(versionInfoFile).then((value) => {
    // console.log(dartSelectors.referenceFiles[key],value);
    if (value !== null) {
      let guidelinePublished = $("<body/>").html(value);
      guidelinePublished = $(guidelinePublished).find("#section_versioninfo").text();

      if (
        dartSelectors.XRefPath === "Antibiotic/abg/c_Traumatic_wound_infections.dita" ||
        dartSelectors.XRefPath === "Antibiotic/abg/c_Parasitic_infections.dita" ||
        dartSelectors.XRefPath === "Antibiotic/abg/c_Perinatal_infections.dita" ||
        dartSelectors.XRefPath === "Antibiotic/Prevention_of_infection.dita"
      ) {
        guidelinePublished = "Published April 2019";
      }

      let uxDocVersion = $('#contentId [outputclass="docversion"]');
      let topicPublished = dateinfo.amended;
      if (topicPublished === "") {
        topicPublished = $(uxDocVersion).text();
        // console.log("I got it");
      }

      if (
        topicPublished.includes("Published") ||
        topicPublished.includes("Last updated") ||
        topicPublished.includes("Last reviewed")
      ) {
        console.log("SUCH PUBLISHED DATE: ", topicPublished);
        $(".reviseddate").html(topicPublished);
      } else {
        console.log("SUCH PUBLISHED DATE: ", guidelinePublished + " " + topicPublished);
        $(".reviseddate").html(guidelinePublished + " " + topicPublished);
      }
    } else {
      dartSelectors.dispatch(
        fetchContent({
          guideline: dartSelectors.ditapath,
          topicFile: versionInfoFile,
          dartSelectors,
        }),
      );
    }
  });
};

let PrepareColapseContent = (dartSelectors) => {
  let uxSectionDisplay = $("#contentId .dartsectiondisplay.active");
  $(uxSectionDisplay).each((index, element) => {
    $(element).closest(".colapsecontent").addClass("active");
  });

  try {
    let firstH2 = $("#contentId h2:eq(0)").attr("filepath");
    let firstH2Level = $('#tg_toc_id [href="' + firstH2 + '"]').attr("level");
    if (parseInt(firstH2Level) > 3) {
      $(".showtandfsection:eq(0)").css("display", "block");
    }
  } catch (error) {}
};

let PrepareTable = (dartSelectors) => {
  let uxTDRowSpan = $("#contentId td[rowspan]");
  $(uxTDRowSpan).each((index, element) => {
    // +1 rowspan
    let rowspanValue = parseInt($(element).attr("rowspan"));
    $(element).attr("rowspan", ++rowspanValue);
    // console.log("rowspanValue",rowspanValue);
  });

  let uxTDNamest = $("#contentId td[namest]");
  $(uxTDNamest).each((index, element) => {
    let namestValue = $(element).attr("namest").replace("col", "");
    namestValue = parseInt(namestValue) - 1;

    let colSpanValue = $(element).attr("colspan");
    if (colSpanValue !== undefined) {
      colSpanValue = parseInt(colSpanValue) - namestValue;
      $(element).attr("colspan", colSpanValue);
    }
  });

  let uxTDNameend = $("#contentId td[nameend]");
  $(uxTDNameend)
    .not("[colspan]")
    .each((index, element) => {
      // console.log($(element).attr("nameend"));
      $(element).attr("colspan", $(element).attr("nameend").replace("c", ""));
    });
};

let PrepareImages = async (dartSelectors) => {
  let uxImg = $("#contentId image, #contentId img");

  uxImg.each((index, element) => {
    let imagePath = $(element).attr("href");
    const urlObj = getUrlObj();
    if (urlObj.href.includes("tgldcdp.tg.org.au") && dartSelectors.ccmsversion.selected === "s1") {
      imagePath = imagePath.replace("../../i", "/fulltext/tglcontent/I");
    } else {
      imagePath = imagePath.replace(
        "../../",
        "https://ccmsfiles.tg.org.au/" + dartSelectors.ccmsversion.selected + "/",
      );
    }
    dartSelectors.iDB.read(imagePath).then((value) => {
      if (value) {
        imagePath = value;
      }
      let id = $(element).attr("id");
      if (id !== undefined) {
        $(`#${id}`).attr("src", imagePath);
        $(`#${id}`).attr("style", "width:auto;max-width:100%;vertical-align:inherit;");
      } else {
        $(element).attr("src", imagePath);
        $(element).attr("style", "width:auto;max-width:100%;vertical-align:inherit;");
      }
    });
  });
};

let PrepareImagemap = (dartSelectors) => {
  $("imagemap").each((index, element) => {
    let elementHTML = $(element).html();
    $(element).html('<map name="' + $(element).attr("id") + '">' + elementHTML + "</map>");
    $(element)
      .find("img")
      .attr("usemap", "#" + $(element).attr("id"));
    $(element).find("img").appendTo(element);

    $(element)
      .find("area")
      .each((area_index, area_element) => {
        try {
          const shapeEl = $(element).find("shape:eq(" + area_index + ")");
          $(area_element).attr("shape", shapeEl.text());

          const coordsEl = $(element).find("coords:eq(" + area_index + ")");
          $(area_element).attr("coords", coordsEl.text());
          // eslint-disable-next-line no-script-url
          $(area_element).attr("href", "javascript:void(0);");

          const xrefEl = $(element).find("xref:eq(" + area_index + ")");
          $(area_element).attr("xref", xrefEl.attr("href"));
          xrefEl.css("display", "none");
          xrefEl.empty();

          // $(area_element).attr("title",$(element).find('xref:eq('+area_index+')').attr("title"));
          $(area_element).html("");
        } catch (error) {
          console.log(window.parent.location.href, error);
        }
      });

    // remove invalid <coods> ans <shape> tags
    $(element).find("coords, shape").remove();

    // $("imagemap").closest("fig").css("border","0px solid #FFF"); // remove border around images
  });

  setTimeout(() => {
    // use imageMapResize to resize images
    // imageMapResize expects valid <map> tags but dita <maps> are invalid HTML => we need to filter with jQuery
    const $targetedMaps = $("imagemap map");
    $targetedMaps.each(function () {
      try {
        imageMapResize(this);
      } catch (error) {
        console.error("Failed to attach resizer to map:", error);
      }
    });
  }, 2000);
};

let PrepareFootNotes = (dartSelectors, isModernView) => {
  let uxFn = $("#contentId fn");

  $(uxFn).each((index, element) => {
    let fnHref = $(element).attr("id");
    // console.log("footnotehref ",fnHref);
    if (fnHref === undefined)
      // apply to footnotes without href only.
      $(element).before(
        " <a href='javascript:{}' footnote='" +
          parseInt(index + 1) +
          "'>[Note " +
          parseInt(index + 1) +
          "]</a>",
      );

    $(element).attr("note", parseInt(index + 1));
    $(element).html("Note " + parseInt(index + 1) + ": " + $(element).html());
    if (isModernView) {
      const $icon = $(
        '<div class="backToOriginalWrap"><i class="tg-icons-Redo backToOriginal" /></div>',
      );
      $(element).append($icon);
    }
    // console.log("section length",$(element).closest("section[id]").attr("id"))
    let ditaSection = $(element).closest("section[id]").attr("id");
    ditaSection = ditaSection.includes("section-") ? "ditacontent" : "section[id]";
    $(element).closest(ditaSection).append(element);
  });

  let uxFnXref = $('#contentId xref[type="fn"]');

  $(uxFnXref).each(function (index, element) {
    let footNoteHref = $(element).attr("href").split("/").splice(-1)[0];
    let fnIndex = $("#" + footNoteHref).attr("note");
    // console.log(footNoteHref,fnIndex);

    $(element).before(
      " <a href='javascript:{}' type='use-by-ref' footnote='" +
        fnIndex +
        "'>[Note " +
        fnIndex +
        "]</a>",
    );
  });
};

let PrepareTableLables = (dartSelectors, renderIcon = false) => {
  let uxTable = $("#contentId table");

  $(uxTable).each((index, element) => {
    let findTOCLink = $(element).attr("id");

    let findConceptID = $("table#" + findTOCLink)
      .closest("concept")
      .attr("id");
    const tocTitleAnchor =
      "#tg_toc_id topicref[href*='" + findConceptID + "/" + findTOCLink + "']:eq(0)";
    let tocTitle = $(tocTitleAnchor).find("ditatitle:eq(0)").html();
    // console.log(tocTitle,index);
    let prevTag = $(element).prev();
    while (1) {
      // console.log(prevTag.prop("tagName"));
      if (prevTag.prop("tagName") === "DITATITLE" || prevTag.prop("tagName") === undefined) {
        renderIcon
          ? $(prevTag)
              .html(tocTitle)
              .wrap("<div class='tableOpenInFull'/>")
              .parent()
              .append('<i class="tg-icons-OpenInFull"></i>')
          : $(prevTag).html(tocTitle);

        $(prevTag).attr("id", "table-" + findTOCLink);

        break;
      } else {
        prevTag = $(prevTag).prev();
      }
    }
    // $(element).siblings("ditatitle").text(tocTitle);
  });
};

let PrepareFigureLables = (dartSelectors, renderIcon = false) => {
  let uxFig = $("#contentId fig");

  $(uxFig).each((index, element) => {
    let findTOCLink = $(element).attr("id");
    let findConceptID = $("fig#" + findTOCLink)
      .closest("concept")
      .attr("id");
    let tocTitle = $("#tg_toc_id topicref[href*='" + findConceptID + "/" + findTOCLink + "']")
      .find("ditatitle:eq(0)")
      .html();
    console.log("in PrepareFigureLables---tocTitle", tocTitle);
    // console.log($("#tg_toc_id topicref[href*='"+findConceptID+"/"+findTOCLink+"']").length,findTOCLink);
    // At appmode, only add OpenInFull icon when fig element contains any images underneath
    const hasImage = $(element).find("img, svg").length > 0;
    renderIcon && hasImage
      ? $(element)
          .find("ditatitle:eq(0)")
          .html(tocTitle)
          .wrap("<div class='figureOpenInFull'/>")
          .parent()
          .append('<i class="tg-icons-OpenInFull"></i>')
      : $(element).find("ditatitle:eq(0)").html(tocTitle); // leave as 0 since its a child not sibling.
  });
};

let PrepareTandFLinks = (dartSelectors, isModernView = false) => {
  //filepath="tandf-xrefs"
  // console.log("tnglinks");
  console.log(" Trigger PrepareTandFLinks function");
  let uxDisplaySection = $(".dartsectiondisplay.active");

  const dartsectionSelector = isModernView === true ? ".appsectiondisplay" : ".dartsectiondisplay";
  console.log("dartsectionSelector", dartsectionSelector);

  let isTandfTablesActive = $('h2[filepath="tandf-tables"]')
    .closest("section")
    .find(dartsectionSelector);
  // console.log("isTandfTablesActive",isTandfTablesActive);

  let isTandfFiguresActive = $('h2[filepath="tandf-figures"]')
    .closest("section")
    .find(dartsectionSelector);
  // console.log("isTandfFiguresActive",isTandfFiguresActive);
  let isTandfXrefsActive = $('h2[filepath="tandf-xrefs"]')
    .closest("section")
    .find(dartsectionSelector);

  if ($(isTandfTablesActive).hasClass("active") || isModernView) {
    // let tableLinks="";

    let uxTnftable = $(".tnftable");
    if (uxTnftable.length > 0) {
      $(isTandfTablesActive).find("ditacontent").html("");
      $(uxTnftable).each((index, element) => {
        let insertContent = "";
        if (localStorage.getItem("tnf") === "show") {
          let tnfTopicContentLink = $(element).attr("href");
          let contentHook = "tandf-tables-" + index;
          insertContent =
            '<div id="' + contentHook + '">Insert content - ' + tnfTopicContentLink + "</div>";
          InsertTandFContent(contentHook, tnfTopicContentLink, dartSelectors);
        }
        // tableLinks = tableLinks + $(element).wrap("<p/>").parent().html()+insertContent;
        $(isTandfTablesActive).find("ditacontent").append(element).append(insertContent);
      });
    }
  }

  if ($(isTandfFiguresActive).hasClass("active") || isModernView) {
    // let figureLinks="";

    let uxTnfFigure = $(".tnffigure");
    if (uxTnfFigure.length > 0) {
      $(isTandfFiguresActive).find("ditacontent").html("");
      $(uxTnfFigure).each((index, element) => {
        // figureLinks = figureLinks + $(element).wrap("<p/>").parent().html();
        let insertContent = "";
        if (localStorage.getItem("tnf") === "show") {
          let tnfTopicContentLink = $(element).attr("href");
          let contentHook = "tandf-figures-" + index;
          insertContent =
            '<div id="' + contentHook + '">Insert content - ' + tnfTopicContentLink + "</div>";
          InsertTandFContent(contentHook, tnfTopicContentLink, dartSelectors);
        }
        $(isTandfFiguresActive).find("ditacontent").append(element).append(insertContent);
      });
    }

    // $(".dartsectiondisplay.active").closest("section").find("ditacontent").html(figureLinks);
  }

  if ($(isTandfXrefsActive).hasClass("active") || isModernView) {
    // let xRefLinks="";

    const tnfXref = $(".tnfxref");
    if (tnfXref.length > 0) {
      $(uxDisplaySection).closest("section").find("ditacontent").html("");
      $(".tnfxref").each((index, element) => {
        // xRefLinks = xRefLinks + $(element).wrap("<p/>").parent().html();
        $(isTandfXrefsActive).find("ditacontent").append(element);
      });
    }

    // $(".dartsectiondisplay.active").closest("section").find("ditacontent").html(xRefLinks);
  }
};

let InsertTandFContent = (contentHook, topicFile, dartSelectors) => {
  setTimeout(() => {
    let topicFileOnly = topicFile.split("#")[0];
    // console.log(topicFileOnly);
    dartSelectors.iDB.read(topicFileOnly).then((value) => {
      // console.log(value);
      if (value !== null) {
        let parsedValue = $("<body/>").html(value);
        let tableToShow = $(parsedValue).find("table").wrap("<p />").parent().html();
        let figureToShow = $(parsedValue).find("fig").wrap("<p />").parent().html();
        let tnftoShow = contentHook.includes("tandf-figures-") ? figureToShow : tableToShow;
        $("#" + contentHook).html(tnftoShow);

        if (contentHook.includes("tandf-figures-")) PrepareImages(dartSelectors);
        PrepareImagemap(dartSelectors);
      } else {
        // console.log("FETCH-TNFContent: ",topicFileOnly);
        dartSelectors.dispatch(
          fetchContent({
            guideline: dartSelectors.ditapath,
            topicFile: topicFileOnly,
            dartSelectors,
          }),
        );
      }
    });
  }, 500);
};

let PerpareXrefs = (dartSelectors) => {
  //Plus reflectives.

  let uxXref = $("#contentId xref");
  $(uxXref).each((index, element) => {
    let xrefText = $(element).html() || "";
    try {
      let currentHref = $(element).attr("href");

      if ($(element).attr("href").includes("/calculator?type=Calculators#")) {
        console.log("currentHref of window.location.host", window.location.host);
        if (window.location.host === "tgldcdp.tg.org.au") {
          currentHref = currentHref.replace(
            "https://tgldcdp.tg.org.au/calculator?type=Calculators#",
            "https://tgldcdp.tg.org.au/calculator/",
          );
        } else if (window.location.host === "app.tg.org.au") {
          currentHref = currentHref.replace(
            "https://tgldcdp.tg.org.au/calculator?type=Calculators#",
            "https://app.tg.org.au/calculator/",
          );
        } else if (window.location.host === "stage.app.tg.org.au") {
          currentHref = currentHref.replace(
            "https://tgldcdp.tg.org.au/calculator?type=Calculators#",
            "https://stage.app.tg.org.au/calculator/",
          );
        } else if (window.location.host === "testtgsf.tg.org.au") {
          currentHref = currentHref.replace(
            "https://tgldcdp.tg.org.au/calculator?type=Calculators#",
            "https://testtgsf.tg.org.au/calculator/",
          );
        }
      }

      if ($(element).attr("href").includes("/calculator/#")) {
        if (window.location.host === "tgldcdp.tg.org.au") {
          currentHref = currentHref.replace(
            "https://tgldcdp.tg.org.au/calculator/#",
            "https://tgldcdp.tg.org.au/calculator/",
          );
        } else if (window.location.host === "app.tg.org.au") {
          currentHref = currentHref.replace(
            "https://tgldcdp.tg.org.au/calculator/#",
            "https://app.tg.org.au/calculator/",
          );
        } else if (window.location.host === "stage.app.tg.org.au") {
          currentHref = currentHref.replace(
            "https://tgldcdp.tg.org.au/calculator/#",
            "https://stage.app.tg.org.au/calculator/",
          );
        } else if (window.location.host === "testtgsf.tg.org.au") {
          currentHref = currentHref.replace(
            "https://tgldcdp.tg.org.au/calculator/#",
            "https://testtgsf.tg.org.au/calculator/",
          );
        }
      }

      if (
        dartSelectors.uxPlatform === "mobile" &&
        $(element).attr("href").includes("/calculator?")
      ) {
        currentHref = currentHref.replace(
          "https://tgldcdp.tg.org.au/calculator?type=Calculators#",
          "https://betatglcontent.tg.org.au/tglcontent/quicklinks/calculator.html#",
        );
      } else if (
        dartSelectors.uxPlatform === "power" &&
        $(element).attr("href").includes("/calculator?")
      ) {
        currentHref = currentHref.replace(
          "https://tgldcdp.tg.org.au/calculator?type=Calculators",
          "/calculator?type=Calculator",
        );
      }
      $(element).attr("href", currentHref);
    } catch (error) {}

    let XrefHref = $(element).attr("href");
    if (typeof XrefHref !== "undefined" && XrefHref !== false) {
      if (XrefHref.indexOf("tgldcdp.tg.org.au") > -1) {
        $(element).attr("href", XrefHref.replace("https://tgldcdp.tg.org.au/", "/"));
      }
      // console.log(XrefHref);
    }

    if (xrefText.length > 0) {
      return;
    } // nothing to do... there is something in there.

    let xrefScope = $(element).attr("scope");
    let xrefHref = $(element).attr("href") || "";
    let xrefConkeyref = $(element).attr("conkeyref") || "";
    let reflectiveText = $(element).text() || "";
    let xrefKeyref = $(element).attr("keyref") || "";

    let textOnTitle = xrefHref === "" ? xrefKeyref : xrefHref;
    textOnTitle = textOnTitle === "" ? xrefConkeyref : textOnTitle;
    // let xrefOtherProps = $(element).attr("otherprops") || "";
    // let xrefTitle = $(element).attr("title");
    // $(element).attr("title","Link: "+textOnTitle); //TODO - meaningful title.

    // console.log("Text=>",xrefText,"|scope",xrefScope,"|URL=>",xrefHref);

    if (xrefScope === "external") {
      $(element).text(xrefHref);
      return;
    }

    //find text in toc...
    reflectiveText =
      $("#tg_toc_id topicref[href*='" + xrefHref + "']:eq(0)")
        .find("ditatitle:eq(0)")
        .text() || "";
    // console.log(reflectiveText);
    // For Table or Figure
    if (reflectiveText.indexOf("Table ") === 0 || reflectiveText.indexOf("Figure ") === 0) {
      reflectiveText = reflectiveText.split(" ");
      reflectiveText = reflectiveText[0] + " " + reflectiveText[1];
      $(element).html(reflectiveText);
      return;
    } else {
      if (reflectiveText.length > 0) {
        $(element).html(reflectiveText); // apply reflective text from toc.
        return;
      }
    }

    // find text on current page.
    if (xrefHref.indexOf("#") === 0 && reflectiveText === "") {
      // console.log(852, xrefHref);
      let linkSelector = "#contentId " + xrefHref.replace(/\//g, " #");
      $(linkSelector).prop("tagName");
      if ($(linkSelector).prop("tagName") === "TABLE") {
        // console.log("this is a table... do table logic.");
        let tableText = "ditatitle#table-" + $(linkSelector).attr("id");
        tableText = $(tableText).text();
        tableText = tableText.split(" ");
        tableText = tableText[0] + " " + tableText[1];
        reflectiveText = tableText;
      } else {
        linkSelector = "#contentId " + xrefHref.replace(/\//g, " #") + " ditatitle";
        reflectiveText = $(linkSelector).text() || "";
        if (reflectiveText.indexOf("Table ") === 0 || reflectiveText.indexOf("Figure ") === 0) {
          reflectiveText = reflectiveText.split(" ");
          reflectiveText = reflectiveText[0] + " " + reflectiveText[1];
        }
      }
      // console.log(reflectiveText);
      if (reflectiveText.length > 0) {
        $(element).html(reflectiveText); // apply local link
        return;
      }
    }

    if (reflectiveText === "") {
      // console.log(738,reflectiveText);
      if (!textOnTitle.includes("pbs_") && !textOnTitle.startsWith("#")) {
        let reflectiveLinkText = xrefHref;
        reflectiveLinkText = reflectiveLinkText === "" ? xrefConkeyref : reflectiveLinkText;
        reflectiveLinkText = reflectiveLinkText === "" ? xrefKeyref : reflectiveLinkText;

        // console.log(dartSelectors);
        $(element).text("here"); // temp till below is executed.
        let lookupLink = reflectiveLinkText;
        // console.log(lookupLink);
        let lookupGuideline = dartSelectors.ditapath;
        if (lookupLink.includes("../../")) {
          lookupLink = lookupLink.replace(/(..\/..\/\w*\/)/g, ""); // e.g. ../../Toxicology_and_Toxinology/ttg/c_ttg1-c05-s2-3.dita#ttg1-c05-s2-3/tttg1-c05-tbl2
          lookupLink = lookupLink.split("#");
          // console.log(lookupGuideline);
          lookupGuideline = reflectiveLinkText.replace("../../", "").split("/")[0] + "/";
          // console.log("lookupLink>>",lookupLink,lookupGuideline);
        } else {
          lookupLink = lookupLink.replace("../", "").split("#");
        }
        // console.log(lookupLink[0]);

        if (lookupLink.length === 1 && !lookupLink[0].includes(".dita") && xrefKeyref !== "") {
          // console.log(reflectiveLinkText,xrefKeyref);
          let drugRef = dartSelectors.cache[dartSelectors.referenceFiles.drug_keydef];
          drugRef = $("<body/>").html(drugRef.content);
          let keyDefHref = $(drugRef)
            .find('[keys~="' + xrefKeyref + '"]')
            .attr("href");
          lookupLink = keyDefHref;
          lookupLink = lookupLink.split("#");
          lookupGuideline = "";
          // console.log(keyDefHref,lookupLink,lookupGuideline);
        }

        if (lookupLink.length > 1 && lookupGuideline === dartSelectors.ditapath) {
          if (lookupLink[1].indexOf("fig-") || lookupLink[1].indexOf("-tbl")) {
            let tnfTocRef = lookupLink[1].split("/").splice(-1)[0];
            // console.log(tnfTocRef);
            let tnfTocText = $('#tg_toc_id [href$="' + tnfTocRef + '"]').text();
            tnfTocText = tnfTocText.split(" ");
            tnfTocText = tnfTocText[0] + " " + tnfTocText[1];
            $(element).text(tnfTocText);
          }
        } else {
          //takes table/figure name from toc file if lookupGuideline not equal to ditapath
          if (hasTableOrFigureReference(lookupLink)) {
            const tableOrFigId = extractTableFigureId(lookupLink);
            dartSelectors.iDB.read(tocFileName(lookupGuideline)).then((value) => {
              if (value !== null) {
                value = $("<body />").html(value);
                let targetElement = $(value).find(`#${tableOrFigId}`);
                if (targetElement.length > 0) {
                  let title = targetElement.find("ditatitle:eq(0)").text();
                  if (title) {
                    console.log("Found table/figure title:", title);
                    $(element).text(extractTableFigureNumber(title));
                  }
                }
              }
            });
          } else {
            dartSelectors.iDB.read(lookupLink[0]).then((value) => {
              let ditaTitle = "";
              if (value !== null) {
                value = $("<body />").html(value);
                if (lookupLink.length > 1) {
                  ditaTitle = $(value)
                    .find("#" + lookupLink[1].replace(/\//g, " #") + " ditatitle:eq(0)")
                    .text();
                  // console.log(ditaTitle);
                  if (ditaTitle === "" && lookupLink[1].includes("-tbl")) {
                    // for tables only.
                    //console.log("startwhile");
                    let tableElement = $(value).find("#" + lookupLink[1].replace(/\//g, " #"));
                    let prevTag = tableElement.prev();
                    while (prevTag.length > 0) {
                      if (prevTag.prop("tagName") === "DITATITLE") {
                        let nextElement = prevTag.next();
                        if (nextElement.is(tableElement)) {
                          ditaTitle = prevTag.text();
                          break;
                        }
                      }
                      prevTag = prevTag.prev();
                    }
                  }
                } else {
                  ditaTitle = $(value).find("ditatitle:eq(0),glossterm:eq(0)").text();
                  // console.log(ditaTitle);
                }
                ditaTitle = ditaTitle === "" ? "here ..." : ditaTitle;
                // console.log(ditaTitle);
                // console.log($(value).html());
                $(element).text(ditaTitle);
              } else {
                // console.log("fetching...>>",lookupLink[0],lookupGuideline);
                if (lookupLink[0].includes("pbf/") && !lookupLink[0].includes("quicklinks/")) {
                  lookupGuideline = "quicklinks/";
                } else if (
                  lookupLink[0].indexOf("g_b_") === 0 ||
                  lookupLink[0].indexOf("g_p_") === 0
                ) {
                  lookupGuideline = "quicklinks/glossary_topics/";
                }
                dartSelectors.dispatch(
                  fetchContent({
                    guideline: lookupGuideline,
                    topicFile: lookupLink[0],
                    dartSelectors,
                  }),
                );
              }
            });
          }
        }

        let sectionFilePath = $(element)
          .closest("section")
          .find("[filepath]:eq(0)")
          .attr("filepath");
        // console.log("sectionFilePath:",sectionFilePath);
        try {
          if (sectionFilePath !== undefined) {
            sectionFilePath = sectionFilePath.split("/");
            sectionFilePath[sectionFilePath.length - 1] = textOnTitle;
            sectionFilePath = sectionFilePath.join("/");
          } else {
            // console.log("textOnTitle:",textOnTitle);
            sectionFilePath = textOnTitle;
            let exactHref = $('#tg_toc_id [href*="' + textOnTitle.split("#")[0] + '"]:eq(0)').attr(
              "href",
            );
            sectionFilePath = sectionFilePath.replace(textOnTitle.split("#")[0], exactHref);
            // console.log(sectionFilePath);
          }

          // console.log("sectionFilePath:",sectionFilePath);

          if (!sectionFilePath.includes(".dita") && xrefKeyref === "") {
            $(element).text("here..."); // TODO - Resolve.
          }
        } catch (error) {
          console.log(773, error);
        }
      }
    }
    // console.log();
  });
};

const hasTableOrFigureReference = (linkArray) => {
  return linkArray.some(
    (link) =>
      link.includes("table-") ||
      link.includes("fig-") ||
      link.includes("-tbl") ||
      link.includes("-fig"),
  );
};

const extractTableFigureId = (linkArray) => {
  //currently the table/figure ID is expected to be in the second part of the link, can be improved if the structure changes in the future
  if (linkArray.length > 1) {
    const secondPart = linkArray[1];

    const parts = secondPart.split("/");
    const lastPart = parts[parts.length - 1];
    console.log("Extracted part:", lastPart, lastPart.includes("table-"));
    if (
      lastPart.includes("table-") ||
      lastPart.includes("fig-") ||
      lastPart.includes("-tbl") ||
      lastPart.includes("-fig")
    ) {
      return lastPart;
    }
  }

  return linkArray.find(
    (link) =>
      link.includes("table-") ||
      link.includes("fig-") ||
      link.includes("-tbl") ||
      link.includes("-fig"),
  );
};

const tocFileName = (guideline) => {
  const normalized = guideline.endsWith("/") ? guideline.slice(0, -1) : guideline;
  return `${normalized}.txt`;
};
export const extractTableFigureNumber = (fullTitle) => {
  const match = fullTitle.match(/^(Table|Figure)\s+\d+\.\d+/);
  return match ? match[0] : fullTitle;
};
export default PrepareToView;
